import type { PaymentMethod } from '@shared/contracts/enums'
import { Money } from '@shared/lib/money/money'
import type { SaleRefund, SaleSplitRole } from './sale.contract'

export function paymentMethodLabel(method: PaymentMethod): string {
  const labels: Record<PaymentMethod, string> = {
    CREDIT_CARD: 'Cartão de crédito',
    PIX: 'Pix',
    BOLETO: 'Boleto',
    PAYPAL: 'PayPal',
    APPLE_PAY: 'Apple Pay',
    GOOGLE_PAY: 'Google Pay',
    AMAZON_PAY: 'Amazon Pay',
  }
  return labels[method]
}

export function lineKindLabel(kind: string): string {
  const labels: Record<string, string> = {
    PRINCIPAL: 'Produto principal',
    BUMP: 'Order bump',
    UPSELL: 'Upsell',
    DOWNSELL: 'Downsell',
  }
  return labels[kind] ?? kind
}

export function participantCommissionLabel(role: SaleSplitRole): string {
  const labels: Record<SaleSplitRole, string> = {
    PRODUCER: 'Parte do produtor',
    COPRODUCER: 'Comissão do coprodutor',
    AFFILIATE: 'Comissão do afiliado',
    SEED: 'Comissão de indicação',
  }
  return labels[role]
}

export function splitRoleLabel(role: SaleSplitRole): string {
  const labels: Record<SaleSplitRole, string> = {
    PRODUCER: 'Produtor',
    COPRODUCER: 'Coprodutor',
    AFFILIATE: 'Afiliado',
    SEED: 'Indicação',
  }
  return labels[role]
}

export function recoveryRatio(refund: SaleRefund): number {
  const refunded = Money.fromMonetaryValue(refund.refundedAmount)
  if (refunded.isZero()) {
    return 0
  }
  const recovered = Money.fromMonetaryValue(refund.recoveredAmount)
  const ratio = recovered.toNumber() / refunded.toNumber()
  if (ratio < 0) {
    return 0
  }
  if (ratio > 1) {
    return 1
  }
  return ratio
}

export function recoveryPercentLabel(refund: SaleRefund): string {
  return `${Math.round(recoveryRatio(refund) * 100)}%`
}
